import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-[#2C2C2C] to-[#1a1a1a] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <img
              src="https://lirp.cdn-website.com/87c1be40/dms3rep/multi/opt/logo-1920w.png"
              alt="Custom Clothiers"
              className="h-12 w-auto mb-6"
            />
            <p className="text-gray-300 text-sm mb-4">
              Premium custom tailoring in Wellesley, MA. Expert bespoke suits, shirts, and blazers crafted to perfection.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/Customclothiersus/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#C4A962] transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://www.instagram.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#C4A962] transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://twitter.com/CustomClous"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#C4A962] transition-colors cursor-pointer"
                aria-label="Twitter"
              >
                <i className="ri-twitter-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Services</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/custom-suits" className="text-gray-300 hover:text-[#C4A962] transition-colors text-sm">
                  Custom Suits
                </Link>
              </li>
              <li>
                <Link to="/custom-shirts" className="text-gray-300 hover:text-[#C4A962] transition-colors text-sm">
                  Custom Shirts
                </Link>
              </li>
              <li>
                <Link to="/custom-blazers" className="text-gray-300 hover:text-[#C4A962] transition-colors text-sm">
                  Custom Blazers
                </Link>
              </li>
              <li>
                <Link to="/alterations" className="text-gray-300 hover:text-[#C4A962] transition-colors text-sm">
                  Alterations
                </Link>
              </li>
              <li>
                <Link to="/service-areas" className="text-gray-300 hover:text-[#C4A962] transition-colors text-sm">
                  House and Office Calls
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Company</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-gray-300 hover:text-[#C4A962] transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/reviews" className="text-gray-300 hover:text-[#C4A962] transition-colors text-sm">
                  Reviews
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-300 hover:text-[#C4A962] transition-colors text-sm">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-[#C4A962] transition-colors text-sm">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/service-areas" className="text-gray-300 hover:text-[#C4A962] transition-colors text-sm">
                  Service Areas
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <i className="ri-map-pin-line text-[#C4A962] mt-1 mr-3"></i>
                <a
                  href="https://maps.app.goo.gl/Qhv3cJXefy3nW8e97"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-[#C4A962] transition-colors text-sm"
                >
                  326A Washington St<br />Wellesley, MA 02481
                </a>
              </li>
              <li className="flex items-center">
                <i className="ri-phone-line text-[#C4A962] mr-3"></i>
                <a href="tel:781-237-3166" className="text-gray-300 hover:text-[#C4A962] transition-colors text-sm">
                  781-237-3166
                </a>
              </li>
              <li className="flex items-center">
                <i className="ri-mail-line text-[#C4A962] mr-3"></i>
                <a href="mailto:info@customclothiers.us" className="text-gray-300 hover:text-[#C4A962] transition-colors text-sm">
                  info@customclothiers.us
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-time-line text-[#C4A962] mt-1 mr-3"></i>
                <div className="text-gray-300 text-sm">
                  <p>Monday – Friday</p>
                  <p>8:00 AM – 5:00 PM</p>
                  <p className="mt-2">Saturday</p>
                  <p>8:00 AM – 4:00 PM</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Custom Clothiers. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/privacy-policy" className="text-gray-400 hover:text-[#C4A962] transition-colors text-sm">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-gray-400 hover:text-[#C4A962] transition-colors text-sm">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;